import convertColor from '@packages/convert-color'
import * as React from 'react'
import { useEffect, useState } from 'react'

type IconProps = {
	iconName: string
	iconSize?: string
	iconStroke?: string
	iconColor?: string
}

// Функция для перевода атрибутов нативного SVG в React-пропсы
const convertAttrsToProps = (element: HTMLElement): Record<string, string> => {
	const props: Record<string, string> = {}
	for (const { name, value } of element.attributes) {
		props[name] = value
	}
	return props
}

// Главная функция: создание React-элемента из нативного SVG
const createSvgElement = (svgEl: HTMLElement): React.ReactElement => {
	const props = convertAttrsToProps(svgEl)
	const children = Array.from(svgEl.childNodes).map((child) => {
		if (child.nodeType === Node.ELEMENT_NODE) {
			return createSvgElement(child as HTMLElement)
		}
		return child.nodeValue || '' // Текстовые узлы
	})

	return React.createElement(svgEl.tagName.toLowerCase(), props, ...children)
}

// Компонент иконки
const IconSvg: React.FunctionComponent<IconProps> = ({
	iconName,
	iconSize = '24',
	iconStroke = '2',
	iconColor = 'currentColor',
}) => {
	const [svgElement, setSvgElement] = useState<HTMLElement | null>(null)

	// Получение обработанного цвета
	const color = convertColor(iconColor) || 'currentColor'

	useEffect(() => {
		async function loadSvg() {
			try {
				const response = await fetch(`https://cdn.jsdelivr.net/npm/@tabler/icons@latest/icons/${iconName}.svg`)
				if (response.ok) {
					const text = await response.text()
					const parser = new DOMParser().parseFromString(text, 'image/svg+xml')
					const svgElement = parser.documentElement


					// Установка атрибутов иконки
					svgElement.setAttribute('stroke', color)
					svgElement.setAttribute('stroke-width', iconStroke)
					svgElement.setAttribute('width', `${iconSize}px`)
					svgElement.setAttribute('height', `${iconSize}px`)
					svgElement.setAttribute('color', color)

					setSvgElement(svgElement)
				}
			} catch (error: any) {
				console.error('Ошибка при загрузке иконки:', error.message)
			}
		}

		loadSvg()
	}, [iconName, iconSize, iconStroke, iconColor])

	return svgElement ? createSvgElement(svgElement) : null
}

export default IconSvg













// Прошлая версия ворачивающая ref
// import { useEffect, useRef } from 'react'

// /*
// Проблемы:
// 1. Цвет иконки задается CSS а не Mantine
// 2. При максимальном размере кнопки, иконка прижата к левому краю
// 3. При переключении варианта, то не применются стили варианта, приходится настраивать вручную цвета иконки и кнопки
// 4. Loading не работает
// */

// // Определяем тип для элемента DOM
// type DomNode = HTMLElement | null

// // Используем стандартный тип RefObject от React для определения ref
// type RefType = React.RefObject<DomNode>

// type IconProps = {
// 	iconSize: string
// 	iconStroke: string
// 	iconColor: string
// 	loading: boolean
// }

// // Функция-загрузчик SVG иконок
// export default (iconName: string, p: IconProps) => {
// 	const ref = useRef<RefType>(null)

// 	useEffect(() => {
// 		async function loadSvg() {
// 			try {
// 				const response = await fetch(`https://cdn.jsdelivr.net/npm/@tabler/icons@latest/icons/${iconName}.svg`)
// 				if (response.ok) {
// 					const text = await response.text() // Преобразуем ответ в текст
// 					const parser = new DOMParser().parseFromString(text, 'image/svg+xml') // Получаем html элемент обёрнутый в #document
// 					const svgElement = parser.documentElement // Вытаскиваем html элемент из обёртки #document

// 					// Установка стилей иконки
// 					svgElement.setAttribute('stroke', p.iconColor || 'currentColor')
// 					svgElement.setAttribute('stroke-width', p.iconStroke || '2')
// 					svgElement.setAttribute('width', p.iconSize ? `${p.iconSize}px` : '24px')
// 					svgElement.setAttribute('height', p.iconSize ? `${p.iconSize}px` : '24px')
// 					svgElement.setAttribute('color', p.iconColor || 'currentColor')

// 					// Удаляем прошлые дочерние svg элементы и добавляем новый
// 					if (ref?.current && ref.current instanceof Element) {
// 						if (ref.current?.firstChild) {
// 							while (ref.current.firstChild) {
// 								ref.current.removeChild(ref.current.firstChild)
// 							}
// 						}
// 						ref.current.appendChild(svgElement)
// 					}
// 				}
// 			} catch (error: any) {
// 				console.error('Ошибка useIconLoader:', error.message)
// 			}
// 		}

// 		loadSvg() // Загружаем иконку
// 	}, [iconName, p.iconSize, p.iconStroke, p.iconColor])

// 	return ref
// }
